import { useEffect, useState } from 'react';
import AllDropDownsAHSF from '../../../../Components/AllDropDownsAHSF';
import './style.css'
import { useDispatch, useSelector } from 'react-redux';
import { GetAllObjective } from '../../../../Redux/Reducers/Submitter/Objectives';
import InputAHSF from '../../../../Components/InputAHSF';
import { GetAllImplementationStageDrpDownList, GetAllImplementationStageList } from '../../../../Redux/Reducers/Submitter/ImplementationStages';
import { AddObjectivesAndActivities, EditObjectivesAndActivities, GetObjectivesAndActivitiesById } from '../../../../Redux/Reducers/Submitter/ObjectivesAndActivities';
import ButtonAHSF from '../../../../Components/ButtonAHSF';
import Select from "react-select";
import $ from "jquery";
import Swal from "sweetalert2";

const ObjectivesAactivitiesAdd = (props) => {
  const allObjective = useSelector((state) => state.ObjectivesReducer.ObjectivesList)
  const ImplementationStagesList = useSelector((state) => state.ImplementationStageReducers.ImplementationStageListDropDown)
  const JsonDataa = useSelector((state) => state.FetchDataJson);

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [activate, setActivate] = useState(null)
  const [SU_NT_WPB_ObjectivesId, setSU_NT_WPB_ObjectivesId] = useState(null)

  const [selectedOptionsValidation, setselectedOptionsValidation] = useState(false);
  const [activateValidation, setactivateValidation] = useState(false)
  const [SU_NT_WPB_ObjectivesIdValidation, setSU_NT_WPB_ObjectivesIdValidation] = useState(false)




  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(GetAllObjective({ applicationInformationId: localStorage.getItem("ApplicationInformationId") }))
    dispatch(GetAllImplementationStageDrpDownList({ applicationInformationId: localStorage.getItem("ApplicationInformationId") }))
  }, [])

  const ObjectivesAndActivities = useSelector((state) => state.ObjectivesAndActivitiesReducers.ObjectivesAndActivities)


  useEffect(() => {
    console.log(ObjectivesAndActivities, "maksdjkjsdkjksajd");

    if (props.ViewData) {
      dispatch(GetObjectivesAndActivitiesById({ ObjectivesAndActivitiesId: props.objectivesAndActivitiesId }))

    }
  }, [])

  const AddObjectivesAactivitiesFun = () => {
    if (validation()) {

      dispatch(AddObjectivesAndActivities({
        SU_NT_WPB_ObjectivesId: SU_NT_WPB_ObjectivesId,
        activities: activate,
        applicationInformationId: localStorage.getItem("ApplicationInformationId"),
        addForObjectivesActiviteImplementationStagesModel: selectedOptions
      }))
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تمت الأضافة بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      $(".close-btn").trigger("click");

    }

  }


  const EditObjectivesAactivitiesFun = () => {
    console.log(validation(), "sdkjsdsdsd");

    if (validation()) {


      dispatch(EditObjectivesAndActivities({
        SU_NT_WPB_ObjectivesId: SU_NT_WPB_ObjectivesId,
        objectivesAndActivitiesId: ObjectivesAndActivities.objectivesAndActivitiesId,
        activities: activate,
        applicationInformationId: localStorage.getItem("ApplicationInformationId"),
        addForObjectivesActiviteImplementationStagesModel: selectedOptions
      }))
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      $(".close-btn").trigger("click");
    }

  }



  useEffect(() => {
    if (props.ViewData) {
      setSelectedOptions(ObjectivesAndActivities?.addForObjectivesActiviteImplementationStagesModel);
      setActivate(ObjectivesAndActivities?.activities);
      setSU_NT_WPB_ObjectivesId(ObjectivesAndActivities?.sU_NT_WPB_ObjectivesId)
    }
  }, [ObjectivesAndActivities])


  const validation = () => {
    let validationStatus = true
    if (!selectedOptions.length) {
      setselectedOptionsValidation(true)
      validationStatus = false
    } else {
      setselectedOptionsValidation(false)
    }

    if (activate == null||activate=="") {
      setactivateValidation(true)
      validationStatus = false
    } else {
      setactivateValidation(false)
    }

    if (SU_NT_WPB_ObjectivesId == null) {
      setSU_NT_WPB_ObjectivesIdValidation(true)
      validationStatus = false
    } else {
      setSU_NT_WPB_ObjectivesIdValidation(false)
    }

    return validationStatus

  }




  const HTML = <>
    <AllDropDownsAHSF
      fieldsName="Objectives"
      show={true}
      disabled={props.shouldDisableFields}
      dropdownType="normal"
      arrayOoptionList={allObjective}
      KeyText={"objectivesName"}
      KeyValue={"sU_NT_WPB_ObjectivesId"}
      defaultValue={
        props.ViewData ? ObjectivesAndActivities?.sU_NT_WPB_ObjectivesId : ""
      }
      onChange={(e) => {
        setSU_NT_WPB_ObjectivesId(e.target.value)
      }}
      showValidationMessage={
        SU_NT_WPB_ObjectivesIdValidation
      }
      validationMessage="يرجى تعبئة هذا الحقل"
    />

    <InputAHSF
      fieldsName="Activate"
      show={true}
      disabled={props.shouldDisableFields}


      onChange={(e) => {
        setActivate(e.target.value);
      }}
      showValidationMessage={activateValidation}
      defaultValue={
        props.ViewData ? ObjectivesAndActivities?.activities : ""
      }
      validationMessage={"حقل اجباري"}
    />

      {
        ImplementationStagesList?.length?<>
        <div className='containerInputAHSF'>
      <label
        className="labeInput"

      >
        {
          JsonDataa?.JsonData?.ImplementationStages?.nameAR
        }
        <label className='showAsterisk'>*</label>
      </label>
      <Select
        isMulti
        options={ImplementationStagesList}
        isDisabled={props.shouldDisableFields}
      
        value={selectedOptions}
        onChange={setSelectedOptions}
        getOptionLabel={(ImplementationStagesList) => ImplementationStagesList.stageName} // تحديد النص الظاهر
        getOptionValue={(ImplementationStagesList) => ImplementationStagesList.implementationStagesId.toString()} // تحديد القيمة المخفية
        className={`basic-multi-select ${selectedOptionsValidation ? "red" : ""}`}
        classNamePrefix="select"
        placeholder="اختر العناصر..."
      />
    </div>
        </>:<></>
      }
    


    {
      props.shouldDisableFields ? <></> : <>

        <div className='ConainerButtonAHSF' id="obAv">
          <ButtonAHSF
            onClick={props.Action == "edit" ? EditObjectivesAactivitiesFun : AddObjectivesAactivitiesFun}
            text={"حفظ"}
            show={true}
          />
        </div>
      </>
    }

  </>
  return (
    <>
      {
        props.Action == "edit" ? ObjectivesAndActivities?.sU_NT_WPB_ObjectivesId ? HTML : <></> : HTML
      }
    </>
  )
}

export default ObjectivesAactivitiesAdd